/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { IAudioContent } from 'src/components/AudiocontentDetail/AudioContentCard/AudioContentCard';
import { MoreToLearnType } from 'src/components/AudiocontentDetail/MoreToLearn/MoreToLearn';
import Const from 'src/config/Const';
import Languages from 'src/utils/beekLanguages';

// @ts-ignore: GraphQL imports are bugged but functional. Ignored for now to make CircleCI happy.
import { Audio, AudioDetail } from 'src/api/audioContent/audioContent.graphql';
// @ts-ignore: GraphQL imports are bugged but functional. Ignored for now to make CircleCI happy.
import { Creatorship } from 'src/api/article/article.graphql';

const getAudiocontentData = (audioDetail: AudioDetail): IAudioContent => {
  const { audio } = audioDetail;
  const languageIndex: any = audio?.language;
  const audioLang: any = Languages[languageIndex]
    ? Languages[languageIndex].translation
    : null;
  return {
    title: audio?.title ? audio?.title : '',
    author:
      audio?.authors != null
        ? audio?.authors
            ?.map((author: Creatorship) => author.creator.name)
            .join(' ')
        : '',
    narrator:
      audio?.narrators != null
        ? audio?.narrators
            ?.map((narrator: Creatorship) => narrator.creator.name)
            .join(' ')
        : '',
    language: audioLang || audio?.language,
    duration: audio?.prettyRuntime ? audio?.prettyRuntime : '',
    cover_url: audio?.coverUrl ? audio?.coverUrl : '',
    average_rating: audio?.averageRating ? audio?.averageRating : 0,
    ratings: audio?.reviewsCount ? audio?.reviewsCount : 0,
    url: audio?.slug ? audio?.slug : '',
    publisher: audio?.publisher.name ? audio?.publisher.name : '',
    sample: audio?.sampleUrl ? audio?.sampleUrl : '',
    book_description: audio?.description
      ? audio?.description.replace(/(<([^>]+)>)/gi, '')
      : '',
  };
};

const getMoreToLearnData = (audioDetail: AudioDetail): MoreToLearnType[] => {
  const { audio } = audioDetail;
  const learnMore = audio?.learnMore;
  const items = learnMore?.map((item: Audio) => {
    return {
      title: item.title != null ? item.title : '',
      author:
        item?.authors != null
          ? item.authors
              ?.map((author: Creatorship) => author.creator.name)
              .join(' ')
          : '',
      cover_url:
        item.coverUrl != null
          ? item.coverUrl
          : `${Const.cdnUrl}/design-system/images/fallbacks/audio_cover.jpg`,
      slug: item.slug != null ? item.slug : `/listas`,
    };
  });
  return items!;
};

const AudiocontentHelpers = {
  getAudiocontentData,
  getMoreToLearnData,
};

export default AudiocontentHelpers;
